var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col flex-1 min-h-0 pt-2 overflow-hidden",attrs:{"id":"admin-list"}},[_c('side-list',{staticClass:"h-full min-h-0",attrs:{"items":_vm.items,"selected-id":_vm.selectedLabel,"id-key":"label"},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
var isItemSelected = ref.isItemSelected;
return [_c('settings-list-item',{attrs:{"is-selected":isItemSelected,"label":item.label,"route":item.route,"icon":item.icon}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }